var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { BaseNumberIdDataDto } from '../../../classes/common/response/base-number-id-data.dto';
import { VendorWithoutRelationsDto } from '../../../classes/vendor/response/vendor-without-relations.dto';
import { UserAuthorityDto } from './user-authority.dto';
export class UserDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.name = initializer.name;
        this.username = initializer.username;
        this.role = initializer.role;
        this.authority = initializer.authority;
        this.phoneNumber = initializer.phoneNumber;
        this.shouldChangePassword = initializer.shouldChangePassword;
        this.vendorId = initializer.vendorId;
        this.vendor = initializer.vendor;
    }
}
__decorate([
    Type(() => UserAuthorityDto),
    __metadata("design:type", UserAuthorityDto)
], UserDto.prototype, "authority", void 0);
__decorate([
    Type(() => VendorWithoutRelationsDto),
    __metadata("design:type", Object)
], UserDto.prototype, "vendor", void 0);
